import Loader from 'react-loaders'
import './index.scss'
import { useEffect, useState } from "react";
import AnimatedLetters from "../AnimatedLetters";
import projectTodo from "../../assets/images/projects/Screenshot_1.png"
import projectCards from "../../assets/images/projects/cards.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

const Projects = () => {
    const projectArray = 'Projects'.split('')

    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        const timer = setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 2000)
        return () => clearTimeout(timer)
    }, [])


    return (
      <>
          <div className="container projects-page">
              <div className="text-zone">
                  <h1>
                      <AnimatedLetters
                        letterClass={letterClass}
                        strArray={projectArray}
                        idx={15}
                      />
                  </h1>
              </div>

              <div className="projects-head todolist">
                  <div className="projects">
                      <div className="projects__body">
                          <a className="projects__link" href="">
                              <img className="projects__img" src={projectCards} alt=""/>
                          </a>
                      </div>
                  </div>

                  <div className="projects-desc">
                      <a className="projects-desc__link" href="https://evgeny3322.github.io/cards-for-learning/#/profile"
                         target={"_blank"}>
                          <p className="projects-desc__title">
                              Cards for learning
                          </p>
                      </a>
                      <div className="projects-desc__work">
                          <p className="projects-desc__text">
                              Реализован проект для изучения нового материала способ - карточки.
                              <hr/> Функционал: профиль пользователя, логинизация,
                              восстановление пароля,
                              хранение данных в DateBase,
                              реакция на ввод неверных символов,
                              создание колоды,
                              ошибки на неверный ввод данных,
                              а также:
                              отображение загрузки на запрос данных,
                              подсказки в виде модульного окна.
                          </p>
                      </div>
                      <div className="projects-icon">
                          <a className="projects-icon__svg" href="https://evgeny3322.github.io/cards-for-learning/#/profile"
                             target={"_blank"}>
                              <FontAwesomeIcon icon={faArrowUpRightFromSquare} color="#ffff"/>
                          </a>
                      </div>
                  </div>
              </div>

              <div className="projects-head ">
                  <div className="projects">
                      <div className="projects__body">
                          <a className="projects__link" href="https://evgeny3322.github.io/todolist-ts/" target={"_blank"}>
                              <img className="projects__img" src={projectTodo} alt=""/>
                          </a>
                      </div>
                  </div>

                  <div className="projects-desc">
                      <a className="projects-desc__link" href="">
                          <p className="projects-desc__title">
                              TodoList
                          </p>
                      </a>
                      <div className="projects-desc__work">
                          <p className="projects-desc__text">
                              Реализовано, полноценное взаимодействие со списком задач, логинизация,хранение данных в DataBase,
                              реакция на ввод неверных символов и данных а также: отображение загрузки на запрос данных, подсказки в
                              виде модульного окна.
                          </p>
                      </div>
                      <div className="projects-icon">
                          <a className="projects-icon__svg" href="https://evgeny3322.github.io/todolist-ts/" target={"_blank"}>
                              <FontAwesomeIcon icon={faArrowUpRightFromSquare} color="#ffff"/>
                          </a>
                      </div>
                  </div>
              </div>

              <div className="projects-head budget">
                  <div className="projects">
                      <div className="projects__body">
                          <a className="projects__link" href="https://evgeny3322.github.io/todolist-ts/" target={"_blank"}>
                              <img className="projects__img" src={projectTodo} alt=""/>
                          </a>
                      </div>
                  </div>

                  <div className="projects-desc">
                      <a className="projects-desc__link" href="">
                          <p className="projects-desc__title">
                              budget
                          </p>
                      </a>
                      <div className="projects-desc__work">
                          <p className="projects-desc__text">
                              Реализовано, полноценное взаимодействие со списком задач, логинизация,хранение данных в DataBase,
                              реакция на ввод неверных символов и данных а также: отображение загрузки на запрос данных, подсказки в
                              виде модульного окна.
                          </p>
                      </div>
                      <div className="projects-icon">
                          <a className="projects-icon__svg" href="https://evgeny3322.github.io/todolist-ts/" target={"_blank"}>
                              <FontAwesomeIcon icon={faArrowUpRightFromSquare} color="#ffff"/>
                          </a>
                      </div>
                  </div>
              </div>


          </div>
          <Loader type="pacman"/>
      </>
    )
}

export default Projects

